import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

export const ChartContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
`;

export const TextsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding-top: 6px;
    line-height: 1;
`;

export const PercentageText = styled.span`
    font-size: 40px;
    font-weight: 300;
    color: ${colorsPalettes.midnight[400]};
`;

export const TrafficText = styled.span`
    font-size: 16px;
    color: ${colorsPalettes.carbon[400]};
`;

export const IconWrapper = styled.div`
    margin-right: 18px;

    .SWReactIcons {
        svg {
            path {
                fill: ${colorsPalettes.blue["500"]} !important;
                fill-opacity: 1;
            }
        }
    }
`;
